import { render, staticRenderFns } from "./PromoBarDockedWrapper.vue?vue&type=template&id=cd4056d8"
import script from "./PromoBarDockedWrapper.vue?vue&type=script&lang=js"
export * from "./PromoBarDockedWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports